import React from 'react'
import styled from '@emotion/styled'
import Spinner from '../generic/spinner.js'

export default ({ loadingInfo, loadingProspectDocuments, resetOptionSelections, urlState }) => {
  const loadingKeys = process.env.BUILD_STAGE === 'build-html' ? [' '] : loadingInfo ? Object.keys(loadingInfo) : []
  const Container = loadingProspectDocuments ? StyledDivFull : React.Fragment
  return (
    <Container>
      <StyledDiv>
        {loadingKeys.length > 0 && (
          <>
            {loadingKeys.map(key => (
              <TextDiv key={key}>{key}</TextDiv>
            ))}
            <SpinnerDiv>
              <Spinner size="30px" />
            </SpinnerDiv>
          </>
        )}
      </StyledDiv>
    </Container>
  )
}

const StyledDivFull = styled.div`
  background-color: rgba(5, 5, 5, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 10;
`

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  right: 0px;
  bottom: 0px;
  margin: 15px;
  margin-bottom: 30px;
`

const SpinnerDiv = styled.div`
  margin-top: 5px;
  height: 30px;
  width: 30px;
`

const TextDiv = styled.div`
  font-size: 11px;
  margin-bottom: 1px;
`
